import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function Anchor({ anchorID }) {
    return _jsx("div", { id: anchorID });
}
//# sourceMappingURL=Anchor.js.map